<template>
  <AdminLayout :use-background-color="false">
    <Head title="Dashboard" />

    <div class="headline flex flex-row justify-between items-center mx-4 sm:mx-12">
      <h2 class="text-2xl font-semibold text-blue-600">Dashboard</h2>

      <div
        v-if="showDashboard"
        class="relative inline-flex shadow-sm rounded-md self-start"
      >
        <div class="input-group">
          <select v-model="form.dashboard">
            <option
              v-for="(option, index) in dashboardOptions"
              :value="option.key"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="bg-gray-100 mt-8">
      <div
        id="metric-overview"
        class="my-5 mx-1 sm:mx-8 lg:mx-5"
      >
        <div
          v-if="showDashboard"
          class="mt-5"
        >
          <iframe
            v-if="dashboardUrl"
            class="w-full"
            :src="dashboardUrl"
            onload="iFrameResize({}, this)"
            allowtransparency
          />
        </div>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import Overview from '@/Pages/Dashboard/Overview'
import DataBox from '@/Components/Cards/DataBox'
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'
import BlankCard from '@/Components/Cards/BlankCard'
import FeedItem from '@/Pages/Dashboard/FeedItem'
import { iframeResize } from 'iframe-resizer'

export default {
  components: {
    FeedItem,
    'report-overview': Overview,
    DataBox,
    BlankCard,
    AdminLayout,
    Head,
    Link
  },

  props: {
    dashboardUrl: {
      type: String,
      default: null
    },
    dashboard: {
      type: String,
      default: 'sales'
    },
    showDashboard: {
      type: Boolean,
      default: true
    },
    dashboardOptions: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      selectedDateRange: this.range,
      form: {
        range: '',
        dashboard: this.dashboard
      },
      visibleActivity: [],
      hiddenActivity: [],
      loaded: false
    }
  },

  created() {
    this.form.range = this.range
    this.form = useForm(this.form)
  },

  watch: {
    selectedDateRange: {
      handler() {
        this.form.range = this.selectedDateRange
        this.pull()
      }
    },
    'form.dashboard': function (newData, oldData) {
      this.pull()
    }
  },

  computed: {
    allActivity() {
      return this.mergeActivity(this.visibleActivity, this.hiddenActivity)
    },
    beforeActivityId() {
      return this.allActivity.length > 0 ? this.allActivity[this.allActivity.length - 1].id : null
    },
    afterActivityId() {
      return this.allActivity.length > 0 ? this.allActivity[0].id : null
    },
    hasNewActivity() {
      return this.hiddenActivity.length > 0
    }
  },

  methods: {
    iframeResize,
    pull() {
      this.form.get(route('dashboard'), {
        onFinish: () => {}
      })
    },
    handleShowNewActivity() {
      if (this.hiddenActivity.length > 0) {
        return this.showNewActivity()
      }

      this.getNewActivity()
    },
    getNewActivity() {
      const params = {
        limit: 20,
        after: this.afterActivityId
      }

      axios.get(route('activity', params)).then((response) => {
        this.hiddenActivity = this.mergeActivity(this.hiddenActivity, response.data)

        if (this.visibleActivity.length < 1) {
          this.showNewActivity()
        }
      })
    },
    showNewActivity() {
      this.visibleActivity = this.mergeActivity(this.visibleActivity, this.hiddenActivity)
      this.hiddenActivity = []
    },
    getPreviousActivity() {
      const params = {
        limit: 20,
        before: this.beforeActivityId
      }

      axios.get(route('activity', params)).then((response) => {
        this.visibleActivity = this.mergeActivity(this.visibleActivity, response.data)
      })
    },
    mergeActivity(arr, toMerge) {
      arr = _.unionWith(arr, toMerge, function (activity, other) {
        return activity.id === other.id
      })
      arr = _.sortBy(arr, function (activity) {
        return -1 * activity.id
      })

      return arr
    },
    getActivityItemStyle(item) {
      switch (item.event) {
        case 'response_fail':
          return 'error'
        default:
          return 'success'
      }
    }
  }
}
</script>

<style scoped>
.nested-enter-active,
.nested-leave-active {
  transition: all 0.3s ease-in-out;
}

.nested-leave-active {
  transition-delay: 0.25s;
}

.nested-enter-from,
.nested-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.nested-enter-active .feed,
.nested-leave-active .feed {
  transition: all 0.3s ease-in-out;
}

.nested-enter-active .feed {
  transition-delay: 0.25s;
}

.nested-enter-from .feed,
.nested-leave-to .feed {
  transform: translateX(30px);
  opacity: 0.001;
}
</style>
